import { AuthService } from './auth';
import { ModuleService } from './modules';
import { ProgressService } from './progress';
import { MediaService } from './media';
import { AdminService } from './admin';
import { SettingsService } from './settings';
import { questionsApi } from './questions';
import { enneagramTypesApi } from './enneagramTypes';
import { createApiConfig } from './config';

class Api {
  public auth: AuthService;
  public admin: AdminService;
  public modules: ModuleService;
  public progress: ProgressService;
  public media: MediaService;
  public settings: SettingsService;
  public questions = questionsApi;
  public enneagramTypes = enneagramTypesApi;

  private token: string | null = null;

  constructor() {
    const config = createApiConfig();
    this.auth = new AuthService(config);
    this.admin = new AdminService(config);
    this.modules = new ModuleService(config);
    this.progress = new ProgressService(config);
    this.media = new MediaService(config);
    this.settings = new SettingsService(config);
  }

  updateToken(token: string | null) {
    this.token = token;
    
    // Update services with new token
    const config = createApiConfig(this.token);
    this.auth = new AuthService(config);
    this.admin = new AdminService(config);
    this.modules = new ModuleService(config);
    this.progress = new ProgressService(config);
    this.media = new MediaService(config);
    this.settings = new SettingsService(config);
    
    // Set token in localStorage for persistence (optional)
    if (token) {
      localStorage.setItem('auth_token', token);
    } else {
      localStorage.removeItem('auth_token');
    }
  }

  getHeaders() {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    };

    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }

    return headers;
  }

  async get<T>(url: string) {
    const response = await fetch(`/api${url}`, {
      method: 'GET',
      headers: this.getHeaders()
    });
    
    if (!response.ok) {
      throw new Error(await response.text());
    }
    
    const data = await response.json();
    return data as T;
  }

  async post<T>(url: string, data: any) {
    const response = await fetch(`/api${url}`, {
      method: 'POST',
      headers: this.getHeaders(),
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      throw new Error(await response.text());
    }
    
    const responseData = await response.json();
    return responseData as T;
  }
}

export const api = new Api();

export * from './errors';